var _g, _path, _path2, _path3, _path4, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgReviewLogo = function SvgReviewLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 117,
    viewBox: "0 0 117 117",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 58.2537,
    cy: 57.2537,
    r: 48.2537,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2832 73.6402L58.6862 89.1196L85.0892 73.6402V42.685L58.6862 27.2091L32.2832 42.685V73.6402ZM58.6868 84.5467L36.1775 71.3504V44.9715L58.6868 31.782L81.1996 44.9715V71.3504L58.6868 84.5467Z",
    fill: "#5E5F5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8141 59.9852L25 78.0859L38.0999 85.4778L56.8141 74.8315L75.5852 85.4326L88.7313 78.0129L56.8141 59.9852Z",
    fill: "#FF5000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0701 28.2296L61.418 19.9255V55.1699L92.3732 72.7315V57.2249L76.0701 47.9775V28.2296Z",
    fill: "#FF2A07"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9552 55.0881V19.9255L41.3031 28.208V47.9144L25 57.2049V72.7315L55.9552 55.0881Z",
    fill: "#DD2321"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 116.507,
    height: 116.507,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
};

export default __webpack_public_path__ + "static/media/review-logo.399aa7e8.svg";
export { SvgReviewLogo as ReactComponent };